<template>
  <div class="home">
    <bar></bar>
	<router-view class="mainRouterView" />
	<foot @jumpCallBack='jumpCallBack'></foot>
  </div>
</template>

<script>
import Bar from '@/components/Bar.vue'
import Foot from '@/components/Foot.vue'
export default {
  name: 'Home',
  components: {
    Bar,
	Foot
  },
  mounted() {
  	// this.$router.go('/main');
	console.log('触发默认路由')
	if(this.isMobile()){
		 window.location.href = "/mobie"
	}
	
	//注册回调，跳转到锚链接
	var _this = this
	window.createdCallBack = function(isCreated){
		if(isCreated){
			var positionDom = document.getElementsByClassName(_this.toPname)[0]
			if(!positionDom){
				
			}else{
				if(positionDom.offsetTop<100){
					window.scrollTo(0,positionDom.offsetTop)
				}else{
					if(_this.$route.path == '/aboutUs'){
						window.scrollTo(0,positionDom.offsetTop)
					}else{
						window.scrollTo(0,positionDom.offsetTop+positionDom.offsetHeight)
					}
				}
			}
			_this.toPname = ''
		}
	}
  },
  data(){
	  return{
		toPname:''
	  }
  },
  methods:{
	  //是移动端返回true,否则false
	  isMobile() {
	    return (/phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|webOS|android/i.test(navigator.userAgent))
	  },
	  jumpCallBack(data){
		console.log('页'+data.page+'锚'+data.pName)
		if(this.$route.path == '/'+data.page){ //如果已经在当前页
			this.toPname=data.pName
			window.createdCallBack(true)
		}else{
			this.toPname=data.pName
			this.$router.push({path:data.page})
		}
	  }
  }
}
</script>

<style scoped="scoped">
	.mainRouterView{
		width: 1920px;
	}
</style>